import { createStore } from 'vuex'

export default createStore({
  state: {
    station: null,
  },
  getters: {
  },
  mutations: {
    setStation(state, newData) {
      state.station = newData;
    },
  },
  actions: {
  },
  modules: {
  }
})
